/* Mockup v3 P9 Modelos > Flujos (v3 `:1866-1871`): the notice, then the flows in a card. */
.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.notice {
  margin: 0;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-sunken);
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.wrap {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  text-align: start;
  vertical-align: middle;
}

.table thead th {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
}

.mono {
  font-family: var(--font-mono);
  font-size: var(--font-size-12);
}

.revision {
  display: inline-block;
  padding: 0 var(--space-2);
  border-radius: var(--radius-pill);
  background: var(--info-surface);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}

.steps {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.step {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

/* The arrow between two steps is decoration: its alternative text is empty, so it is not read. */
.step + .step::before {
  content: "\2192" / "";
  color: var(--text-subtle);
}

.badge {
  display: inline-block;
  padding: 0 var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  font-size: var(--font-size-12);
}
